// extracted by mini-css-extract-plugin
module.exports = {"cardList":"ForumActivities_cardList__2T2wG","answer":"ForumActivities_answer__3dIgx","title":"ForumActivities_title__1n4ii","answerText":"ForumActivities_answerText__36UWm"};